import { SxProps, Theme } from '@mui/material';

export const getAuditLogDetailStyles = (isDark: boolean): Record<string, SxProps<Theme>> => ({
  paper: {
    backgroundColor: isDark ? '#1a222c' : '#ffffff',
    color: isDark ? '#ffffff' : '#111827',
    borderRadius: '16px',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    backgroundImage: 'none',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 3,
    py: 2,
    fontSize: '1.25rem',
    fontWeight: 600,
    borderBottom: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'}`,
    color: isDark ? '#ffffff' : '#111827',
  },
  content: {
    p: 3,
    backgroundColor: isDark ? '#111827' : '#f9fafb',
    maxHeight: '70vh',
    overflowY: 'auto',
  },
  pre: {
    margin: 0,
    fontFamily: "'JetBrains Mono', 'Fira Code', 'Roboto Mono', monospace",
    fontSize: '0.85rem',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    color: isDark ? '#e5e7eb' : '#374151',
    lineHeight: 1.6,
  },
  actions: {
    px: 3,
    py: 2,
    borderTop: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'}`,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1.5,
  },
  closeBtn: {
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1,
    borderRadius: '8px',
    bgcolor: '#00b3f5',
    color: '#fff',
    '&:hover': {
      bgcolor: '#0090c4',
    },
  },
  downloadBtn: {
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1,
    borderRadius: '8px',
    bgcolor: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
    color: isDark ? '#8698a6' : '#5d7182',
    border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    '&:hover': {
      bgcolor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
      color: isDark ? '#ffffff' : '#111827',
    },
  },
});
